import React, { FC } from 'react'

import { ProductDisplay } from '@Components/Product/Display'

const ProductDisplayBlock: FC = () => <ProductDisplay />

export default ProductDisplayBlock
